'use client';

interface VideoContainerProps {
    iframeHtml: string;
}

export default function VideoContainer({ iframeHtml }: VideoContainerProps) {
    return <div className="video-container" dangerouslySetInnerHTML={{ __html: iframeHtml }} />;
}
